// extracted by mini-css-extract-plugin
module.exports = {"UpperSidedrawerOption":"UpperSidedrawerOption_UpperSidedrawerOption__2qHQU","Label":"UpperSidedrawerOption_Label__1YTw9"};